import React from "react";
import AutoScroll from "embla-carousel-auto-scroll";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "./carousel";

// Partner brand logos — existing + new
import partnerLogo1 from "../../assets/partner-logo-1.png";
import partnerLogo2 from "../../assets/partner-logo-2.png";
import partnerLogo3 from "../../assets/partner-logo-3.png";
import partnerLogo4 from "../../assets/partner-logo-4.png";
import partnerLogo5 from "../../assets/partner-logo-5.png";
import partnerLogo6 from "../../assets/partner-logo-6.png";
import partnerLogo7 from "../../assets/partner-logo-7.png";
import partnerLogo8 from "../../assets/partner-logo-8.png";
import partnerLogo9 from "../../assets/partner-logo-9.png";
import partnerLogo10 from "../../assets/partner-logo-10.png";
import partnerLogo11 from "../../assets/partner-logo-11.png";
import newLogo1 from "../../assets/1.png";
import newLogo2 from "../../assets/2.png";
import newLogo3 from "../../assets/3.png";
import newLogo4 from "../../assets/4.png";
import newLogo5 from "../../assets/5.png";
import newLogo6 from "../../assets/6.png";
import newLogo7 from "../../assets/7.png";

const defaultLogos = [
  { id: "logo-1", image: partnerLogo1, className: "h-12 w-auto" },
  { id: "logo-2", image: partnerLogo2, className: "h-12 w-auto" },
  { id: "logo-3", image: partnerLogo3, className: "h-12 w-auto" },
  { id: "logo-4", image: partnerLogo4, className: "h-12 w-auto" },
  { id: "logo-5", image: partnerLogo5, className: "h-12 w-auto" },
  { id: "logo-6", image: partnerLogo6, className: "h-12 w-auto" },
  { id: "logo-7", image: partnerLogo7, className: "h-12 w-auto" },
  { id: "logo-8", image: partnerLogo8, className: "h-12 w-auto" },
  { id: "logo-9", image: partnerLogo9, className: "h-12 w-auto" },
  { id: "logo-10", image: partnerLogo10, className: "h-12 w-auto" },
  { id: "logo-11", image: partnerLogo11, className: "h-12 w-auto" },
  { id: "logo-12", image: newLogo1, className: "h-12 w-auto" },
  { id: "logo-13", image: newLogo2, className: "h-12 w-auto" },
  { id: "logo-14", image: newLogo3, className: "h-12 w-auto" },
  { id: "logo-15", image: newLogo4, className: "h-12 w-auto" },
  { id: "logo-16", image: newLogo5, className: "h-12 w-auto" },
  { id: "logo-17", image: newLogo6, className: "h-12 w-auto" },
  { id: "logo-18", image: newLogo7, className: "h-12 w-auto" },
];

const Logos3 = ({
  heading = "Trusted by these brands",
  logos = defaultLogos,
  className,
}) => {
  return (
    <section className={`py-16 bg-white ${className || ""}`}>
      <div className="container mx-auto px-4 flex flex-col items-center text-center">
        <h2 className="text-base text-primary font-semibold tracking-wide uppercase">
          {heading}
        </h2>
      </div>
      <div className="pt-10">
        <div className="relative mx-auto flex items-center justify-center max-w-5xl">
          <Carousel
            opts={{ loop: true }}
            plugins={[AutoScroll({ playOnInit: true })]}
          >
            <CarouselContent className="ml-0">
              {logos.map((logo) => (
                <CarouselItem
                  key={logo.id}
                  className="flex basis-1/3 justify-center pl-0 sm:basis-1/4 md:basis-1/5 lg:basis-1/6"
                >
                  <div className="mx-6 flex shrink-0 items-center justify-center">
                    <img
                      src={logo.image}
                      alt={logo.description || "Partner brand"}
                      className={`${logo.className} object-contain opacity-70 hover:opacity-100 transition-opacity duration-300`}
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          {/* Fade edges */}
          <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent pointer-events-none"></div>
          <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
        </div>
      </div>
    </section>
  );
};

export { Logos3 };
export default Logos3;
